<template>
  <div style="height: 100%;     overflow-y: auto;">
    <Topbar
      v-if="this.$store.state.topbar_actions_visible"
      @action="getAction"
      @changeFileError="changeFileError"
    ></Topbar>
    <v-layout row xs12 sm12 md12 style="height:100%">
      <v-flex xs3 sm3 md3 id="filters">
        <div>
          <div id="search" style="margin-bottom:15px;">
            <v-text-field hide-details prepend-icon="search" single-line v-model="search"></v-text-field>

            <!-- <v-btn icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn> -->
          </div>
          <v-combobox
            v-model="chips"
            :items="items"
            label="Tags"
            chips
            clearable
            prepend-icon="filter_list"
            solo
            multiple
          >
            <template v-slot:selection="data">
              <v-chip :selected="data.selected" close @input="remove(data.item)">
                <strong>{{ data.item }}</strong>
              </v-chip>
            </template>
          </v-combobox>
        </div>
        <div style="width:100%">
          <v-btn @click="applyFilters" depressed class="bttn do_filter">{{ "filters.apply" | i18n }}</v-btn>
          <v-btn @click="resetFilters" depressed class="bttn reset" small>{{ "filters.reset" | i18n }}</v-btn>
        </div>
        
      </v-flex>
      <v-flex xs9 sm9 md9 id="documents">
        <div v-for="document in documents" class="document" v-if="document.visible">
          <div class="actions">
            <!-- <img src="/img/link.svg" /> -->
            <img style="height:20px!important" @click="preview(document)" src="/img/eye_dark.svg" />
            <img @click="edit(document)" src="/img/edit_dark.svg" />
            <img @click="deleteD(document)" src="/img/delete_dark.svg" />
          </div>
          <div class="info">
            <div v-if="['XLS', 'PDF', 'JPG'].includes(document.fileType)" class="fileSVG"><img :src="`/img/${document.fileType.toLowerCase()}.svg`"></div>
            <div v-else class="fileSVG"><img :src="`/img/file.svg`"></div>
            <div class="tags">
              <span class="name">{{document.name}}</span>

              <div>
                <span class="title">Tags:</span>
                <span class="tag" v-for="tag in document.tags" v-if="tag">#{{tag}}</span>
              </div>
              <div>
                <span class="title" >Pages:</span>
                <span class="tag" v-for="page_id in document.pages" >{{pages[page_id].name}}, </span>
              </div>
              
            </div>
          </div>
          <LastUpdate :data="{name: $store.getters['user/getList'](document.last_user_modify).name  , date: document.last_update}"></LastUpdate>
          <!-- <span class="information_user">{{$t( 'last_update' )}}: {{document.last_update}}</span> -->
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import i18n from "@/i18n";
import { Api } from "@/core/api.js";
import Topbar from "@/components/ui/Topbar";
import LastUpdate from "@/components/ui/LastUpdate";

const api = new Api();

export default {
  name: "DocumentationProfile",
  components: { Topbar, LastUpdate },
  props: { page: String, action: String },
  data() {
    return {
      search: "",
      chips: [],
      items: [],
      fileError: false
    };
  },
  computed: {
    documents() {
      var documents = JSON.parse(
        JSON.stringify(this.$store.getters["documentation/getList"]())
      );
      for (const key in documents) {
        documents[key].tags = documents[key].tags.split(",");
        var fileType = documents[key].src
          .split("/")
          .reverse()[0]
          .split(".")[1];
        documents[key].fileType = fileType.toUpperCase();
      }
      
      return documents;
    },
    pages(){
      var pages = this.$store.getters["documentation/getPages_document"]();
      return pages;
    }
  },
  created() {
    this.$store.commit("setTopbarActionsVisible", true);
    this.$store.commit("setMenuVisible", true);
    var id = this.$route.params.id;
    var event = this.$store.getters.isEventSelected
      ? this.$store.getters["events/getCurrentEvent"]()
      : false;
    this.$store
      .dispatch("documentation/loadList", event.id)
      .then(function() {});
      this.$store
      .dispatch("documentation/loadPages")
      .then(function() {});
    this.$overlay.hide();
  },
  methods: {
    getAction(params) {
      if (params.action == "import") this.saveFile(params);
    },
    changeFileError(state) {
      this.fileError = state;
    },
    changeState(id) {
      var cTransactions = { ...this.transactions };
      cTransactions[id].added = !cTransactions[id].added;
      this.transactions = cTransactions;
    },
    resetFilters(){
      this.search = "";
      this.chips = [];
      this.applyFilters();
    },
    applyFilters() {
      this.$store.commit("documentation/applyFilters", {search: this.search, chips: this.chips})
    },
    saveFile(params) {
      var file = params.file;
    },
    preview(document) {
      window.open(document.src + '/?' + moment().unix(), "_blank");
    },
    edit(document) {
      var event = this.$store.getters.isEventSelected
        ? this.$store.getters["events/getCurrentEvent"]()
        : false;
      this.$router.push({
        name: "event_documentation_edit",
        params: {
          id: document.id,
          event: event
            ? this.$root
                .formatEventUrl(event.name, event.edition)
                .replace("/event/", "")
            : null
        }
      });
    },
    deleteD(document) {
      var self = this;
      this.$popup.confirm(
        {
          message: i18n.t("documentation.delete"),
          btnSuccess: i18n.t("accept"),
          btnError: i18n.t("cancel")
        },
        function() {
          self.$store
            .dispatch("documentation/deleteDocument", document)
            .then(function() {});
        },
        function(err) {}
      );
    },
    remove(item) {
      this.chips.splice(this.chips.indexOf(item), 1);
      this.chips = [...this.chips];
    }
  }
};
</script>

<style lang="scss" >
#filters {
  border-right: 1px solid;
  padding: 10px;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

#documents {
  padding: 10px;
  margin-top: 10px;
  height: fit-content;
  overflow-y: scroll;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  .document {
    width: 30%;
    margin: 6px 1.5%;
    max-height: 150px;
    > #last_update_component {
      margin-top: 0px!important;
      border-top: 0px solid #ccc !important;
    }
  }
  .actions {
    img {
      height: 15px;
      cursor: pointer;
      margin-right: 10px;
      &:last-child {
        margin-right: 2px;
      }
    }
    align-items: center;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 5px;
  }
  .info {
    cursor: pointer;
    background-color: #ffffff;
    border-color: #eeeeee;
    padding: 0.75rem 1.25rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    display: flex;
    .fileType {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px;
      border-radius: 2px;
      background-color: #eeeeee;
      margin-right: 10px;
    }
    .fileSVG{
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        height: 50px;
      }
    }
    
    .tags {
      display: flex;
      flex-direction: column;
      .title{
        color: #77777777;
        font-size: 14px!important;
        text-transform: uppercase;
      }
      .name {
        color: #444444;
        font-size: 20px;
      }
      .tag {
        font-size: 12px;
        margin-right: 1px;
      }
    }
  }
  .information_user{
    font-size: 12px;
  }
}

#btn_search {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  background-color: #aaa;
  color: black;
  cursor: pointer;
}

#imports {
  right: 5px;
}

.bttn {
    width: 100%!important;
    margin: 6px 0px!important;
    text-transform: none!important;

    &.do_filter {
        background-color: $complem-color !important;
        color: #fff!important;
    }
    &.reset {
        color: #999!important;
        

        .v-btn__content {
            font-size: 14px!important;
        }
    }
}


</style>
